import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from "./InnerHeader";
import { StyledDataGrid } from "./StyledDataGrid";
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import LectureReportpdf from "./Document/LectureReportpdf";
import { pdf } from "@react-pdf/renderer";

const LectureReport = () => {

    const [course, setCourse] = useState([])
    const [lecture, setLecture] = useState([])
    const [faculty, setFaculty] = useState([])
    const [value, setValue] = useState({
        faculty: '',
        course: '',
        batch: '',
        lecture: '',
        months: '',
        year: ''
    });

    const [batch, setAnnulBatch] = useState([])
    const [hide, setHide] = useState(false)
    const [vendordata, setStudent] = useState([])
    const [errors, setErrors] = useState({});

    const [lecturereport, setLectureReport] = useState([])
    const [loading, setLoading] = useState([true])
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });




    const getbatch = async (id) => {

        const data = {
            courseid: id
        }

        try {
            const res = await axios.post(`${BASE_URL}/getcoursewisebatch`, data);
            setAnnulBatch(res.data);
        } catch (err) {
            console.error(":", err);
        }
    };


    const getbatchwiselecture = (id) => {

        const data = {
            batch_code: id
        }

        axios.post(`${BASE_URL}/getbatchidwiselecture`, data)
            .then((res) => {
                setLecture(res.data)
            })
    }

    // async function getLectureReportData() {

    //     axios.get(`${BASE_URL}/lecturereport`)
    //         .then((res) => {
    //             console.log(res.data)
    //             setLectureReport(res.data)

    //             setLoading(false)
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //         })
    // }

    async function getCourseData() {

        axios.get(`${BASE_URL}/getCourse`)
            .then((res) => {
                setCourse(res.data)
                setLoading(false)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    async function getFaculty() {

        axios.get(`${BASE_URL}/getfaculty`)
            .then((res) => {
                setFaculty(res.data)

            })
            .catch((err) => {
                console.log(err)
            })
    }





    const handleSubmit = (e) => {
        e.preventDefault();

        const newErrors = {};

        if (!value.course) {
            newErrors.course = "Course is required";
            alert("Course is required");
        }

        if (!value.batch) {
            newErrors.batch = "Batch is required";
            alert("Batch is required");
        }

        // Add other validations as needed

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            return; // Stop form submission
        }

        const data = {
            course: value.course,
            batch: value.batch,
            lecture: value.lecture,
            faculty: value.faculty,

        }


        axios.post(`${BASE_URL}/getlecturereport`, data)
            .then((res) => {
                setHide(true)
                console.log(res.data)
                setLectureReport(res.data)



            })
            .catch((err) => {
                console.log(err)
            })
        // Proceed with form logic
        console.log("Form submitted with:", value);
    };


    const handleSubmit2 = (e) => {
        e.preventDefault();

        const newErrors = {};
        if (!value.months) {
            newErrors.months = "Month is required.";
            alert("Month is required.");
        }
        if (!value.year) {
            newErrors.year = "Year is required.";
            alert("Year is required.");
        }

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        axios.post(`${BASE_URL}/getlecturereport`, {
            month: value.months,
            year: value.year

        })
            .then((res) => {
                setLectureReport(res.data)
                setHide(true)
            })
            .catch((err) => {
                console.error(err);
            });
    };


    const exportToExcel = () => {
        // ✅ Export to Excel here
        const worksheet = XLSX.utils.json_to_sheet(lecturereport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Lecture Report");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

        saveAs(blob, "Lecture_Report.xlsx");
    }

    const makepdf = async () => {
        try {

            const blob = await pdf(<LectureReportpdf data={lecturereport} />).toBlob();

            const url = URL.createObjectURL(blob);

            // Display PDF in a new tab
            window.open(url);

            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error generating PDF:", err);
        }


    }



    const roledata = {
        role: Cookies.get(`role`),
        pageid: 60,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        getFaculty()
        getCourseData()
        dispatch(getRoleData(roledata));
    }, []);


    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const columns = [
        {
            field: 'Take_Id',
            headerName: 'Take Id',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },

        { field: 'Lecture_Name', headerName: 'Lecture', flex: 2 },
        {
    field: 'Take_Dt',
    headerName: 'Date',
    flex: 2,
    renderCell: (params) => {
        if (!params.value) return "";

        // If already DD-MM-YYYY
        const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
        if (ddmmyyyyRegex.test(params.value)) {
            return params.value;
        }

        // If yyyymmdd (no dashes)
        if (/^\d{8}$/.test(params.value)) {
            const year = params.value.substring(0, 4);
            const month = params.value.substring(4, 6);
            const day = params.value.substring(6, 8);
            return `${day}-${month}-${year}`;
        }

        // If yyyy-mm-dd or Date string
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return "";

        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    }
},

        { field: 'Batch_code', headerName: 'Batch', flex: 2 },
        { field: 'Topic', headerName: 'Topic', flex: 2 },
        { field: 'Faculty_Name', headerName: 'Faculty Name', flex: 2 },
        { field: 'Lecture_Start', headerName: 'Start Time', flex: 2 },
        { field: 'Lecture_End', headerName: 'End Time', flex: 2 },


    ];

    const rowsWithIds = lecturereport.map((row, index) => ({ index: index + 1, ...row }));

    return (

        <div class="container-fluid page-body-warpper ">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class='card-title'>
                                        Leacture Search
                                    </h4>
                                    <hr></hr>

                                    <form class="form-sample py-3" onSubmit={handleSubmit} >
                                        <div class="row">
                                            <div class="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Course<span class="text-danger">*</span></label>
                                                <select class="form-control" id="exampleFormControlSelect1" value={value.course}
                                                    name="course" onChange={(e) => {
                                                        getbatch(e.target.value)

                                                        onhandleChange(e);
                                                    }
                                                    }>
                                                    <option>--Select Course--</option>

                                                    {course.map((item) => {
                                                        return (
                                                            <option value={item.Course_Id}>{item.Course_Name}</option>
                                                        )
                                                    })}
                                                    {errors.course && <span className="text-danger">{errors.course}</span>}
                                                </select>
                                            </div>

                                            <div class="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Batch<span class="text-danger">*</span></label>
                                                <select class="form-control" id="exampleFormControlSelect1" value={value.batch}
                                                    name="batch" onChange={(e) => {
                                                        getbatchwiselecture(e.target.value)

                                                        onhandleChange(e);
                                                    }}>
                                                    <option>--Select Batch--</option>

                                                    {batch.map((item) => {
                                                        return (
                                                            <option value={item.Batch_Id}>{item.Batch_code}</option>
                                                        )
                                                    })}
                                                    {errors.batch && <span className="text-danger">{errors.batch}</span>}

                                                </select>
                                            </div>

                                            <div class="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Lecture</label>
                                                <select class="form-control" id="exampleFormControlSelect1" value={value.lecture}
                                                    name="lecture" onChange={onhandleChange}>
                                                    <option>--Select Lecture--</option>
                                                    {lecture.map((item) => {
                                                        return (
                                                            <option value={item.id}>{item.subject_topic}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>

                                            <div class="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Faculty</label>
                                                <select class="form-control" id="exampleFormControlSelect1" value={value.faculty}
                                                    name="faculty" onChange={onhandleChange}>
                                                    <option>--Select Faculty--</option>
                                                    {faculty.map((item) => {
                                                        return (
                                                            <option value={item.Faculty_Id}>{item.Faculty_Name}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>

                                            <div class='d-flex align-items-center mt-3 col-lg-3'>
                                                <button type="submit" class="btn btn-sm btn-primary mr-5">Go</button>
                                            </div>

                                        </div>
                                    </form>

                                    <form onSubmit={handleSubmit2}>
                                        <div className='row'>
                                            <div class="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Months<span class="text-danger">*</span></label>
                                                <select class="form-control" id="exampleFormControlSelect1" value={value.months}
                                                    name="months" onChange={onhandleChange}>
                                                    <option>--Select Months--</option>
                                                    <option value="0">Select</option>
                                                    <option value="1">January</option>
                                                    <option value="2">February</option>
                                                    <option value="3">March</option>
                                                    <option value="4">April</option>
                                                    <option value="5">May</option>
                                                    <option value="6">June</option>
                                                    <option value="7">July</option>
                                                    <option value="8">August</option>
                                                    <option value="9">September</option>
                                                    <option value="10">October</option>
                                                    <option value="11">November</option>
                                                    <option value="12">December</option>
                                                </select>
                                            </div>

                                            <div class="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Year<span class="text-danger">*</span></label>
                                                <select class="form-control" id="exampleFormControlSelect1" value={value.year}
                                                    name="year" onChange={onhandleChange}>
                                                    <option>--Select Year--</option>
                                                    <option value="2027">2027</option>
                                                    <option value="2026">2026</option>
                                                    <option value="2025">2025</option>
                                                    <option value="2024">2024</option>
                                                    <option value="2023">2023</option>
                                                    <option value="2022">2022</option>
                                                    <option value="2021">2021</option>
                                                    <option value="2020">2020</option>
                                                    <option value="2019">2019</option>
                                                    <option value="2018">2018</option>
                                                    <option value="2017">2017</option>
                                                    <option value="2016">2016</option>
                                                    <option value="2015">2015</option>
                                                    <option value="2014">2014</option>
                                                    <option value="2013">2013</option>
                                                    <option value="2012">2012</option>
                                                    <option value="2011">2011</option>
                                                    <option value="2010">2010</option>
                                                    <option value="2009">2009</option>
                                                    <option value="2008">2008</option>
                                                    <option value="2007">2007</option>
                                                    <option value="2006">2006</option>
                                                    <option value="2005">2005</option>
                                                    <option value="2004">2004</option>
                                                    <option value="2003">2003</option>
                                                    <option value="2002">2002</option>
                                                    <option value="2001">2001</option>
                                                </select>
                                            </div>
                                            <div class='d-flex align-items-center mt-3 col-lg-3'>
                                                <button type="submit" class="btn btn-sm btn-primary mr-2">Go</button>
                                                <button
                                                    type="reset"
                                                    onClick={() => {
                                                        setValue({});
                                                        setErrors({});
                                                        setLectureReport([])
                                                        setHide(false)
                                                    }}
                                                    className="btn btn-sm btn-primary mr-2"
                                                >
                                                    Clear All
                                                </button>
                                                {/* <button type="submit" class="btn btn-sm btn-primary mr-2">Back</button> */}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        {hide && <div class="col-lg-12">
                            <div class="card">
                                <div class="card-body">
                                    <div className="d-flex justify-content-warrper" style={{ borderBottom: "2px solid #dce4ec", width: "100%" }}>
                                        <div>
                                            <h4 class="card-title">Details</h4>
                                        </div>
                                    </div>
                                    <div style={{ borderLeft: "1px solid #dce4ec", height: "510px", overflow: "hidden" }}>
                                        <StyledDataGrid
                                            rows={rowsWithIds}
                                            columns={columns}
                                            // disableColumnFilter
                                            disableColumnSelector
                                            disableDensitySelector
                                            rowHeight={35}
                                            getRowId={(row) => row.Take_Id}
                                            pagination
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={setPaginationModel}
                                            pageSizeOptions={[50]}
                                            autoHeight={false}
                                            sx={{
                                                height: 500, // Ensure enough height for pagination controls
                                                '& .MuiDataGrid-footerContainer': {
                                                    justifyContent: 'flex-end',
                                                },
                                            }}
                                            slots={{
                                                toolbar: GridToolbar
                                            }}
                                            slotProps={{
                                                toolbar: {
                                                    showQuickFilter: true,
                                                },
                                            }}
                                        />
                                    </div>

                                    <button type="Submit" class="btn btn-primary mr-2" onClick={exportToExcel}>Excel</button>
                                    <button type='button' onClick={() => {
                                        makepdf()
                                    }} class="btn btn-light">Print</button>

                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>

    )


}
export default LectureReport